module.exports = __webpack_public_path__ + "img/change_image.fec0bd1f.svg";